var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileChips = function SvgProfileChips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__a)",
    stroke: "url(#profileChips_svg__b)",
    strokeLinejoin: "round",
    strokeWidth: 0.94,
    d: "M9.022 16.978a7.977 7.977 0 1 0 0-15.955 7.977 7.977 0 0 0 0 15.955Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__c)",
    d: "M10.981 1.266a8 8 0 0 0-3.9-.004c-.157.61-.17 2.46 1.944 7.739 2.18-5.253 2.134-7.116 1.956-7.735"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__d)",
    d: "M3.303 3.44a8 8 0 0 0-1.955 3.372c.448.442 2.038 1.38 7.676 2.189-3.46-4.516-5.096-5.407-5.721-5.562"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__e)",
    d: "M1.346 11.177a8 8 0 0 0 1.95 3.375c.608-.169 2.217-1.082 5.73-5.552-5.652.74-7.237 1.714-7.68 2.177"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__f)",
    d: "M7.07 16.736a8 8 0 0 0 3.899.002c.158-.613.17-2.463-1.944-7.738-2.182 5.256-2.135 7.118-1.956 7.736"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__g)",
    d: "M14.743 14.56a7.97 7.97 0 0 0 1.955-3.376c-.453-.443-2.051-1.378-7.673-2.184 3.453 4.506 5.09 5.403 5.718 5.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__h)",
    d: "M16.7 6.828a7.97 7.97 0 0 0-1.949-3.379c-.611.172-2.22 1.091-5.726 5.552 5.635-.738 7.227-1.708 7.676-2.173"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#161616",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M9.022 14.604a5.604 5.604 0 1 0 0-11.208 5.604 5.604 0 0 0 0 11.208Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DC9C1C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M9.022 13.69a4.688 4.688 0 1 0 0-9.378 4.688 4.688 0 0 0 0 9.377Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__i)",
    d: "M9.022 13.69a4.688 4.688 0 1 0 0-9.378 4.688 4.688 0 0 0 0 9.377"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBCD92",
    d: "M9.023 13.6a4.599 4.599 0 1 0 0-9.198 4.599 4.599 0 0 0 0 9.198"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__j)",
    d: "m11.38 10.999.89-.888V8.758c0-.97-.786-1.754-1.756-1.754H8.139l-.889.888h4.131v3.107"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__k)",
    d: "M11.382 7.892a.89.89 0 0 0-.89-.888H9.062v.888z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__l)",
    d: "m6.934 7.004-.89.888v1.353c0 .97.787 1.754 1.758 1.754h2.374l.89-.888H6.934z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileChips_svg__m)",
    d: "M6.934 10.111c0 .492.397.888.89.888h.937v-.888z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    d: "m9.535 8.884-.603-.348a.138.138 0 0 0-.207.12v.694c0 .105.114.171.207.119l.603-.344a.138.138 0 0 0 0-.24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__a",
    x1: 9.022,
    x2: 9.022,
    y1: 16.978,
    y2: 1.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__b",
    x1: 9.022,
    x2: 9.022,
    y1: 17.001,
    y2: 1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#242320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#272726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__c",
    x1: 9.039,
    x2: 9.039,
    y1: 3.466,
    y2: 15.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7D9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__d",
    x1: 4.236,
    x2: 14.52,
    y1: 6.223,
    y2: 12.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7D9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__e",
    x1: 4.224,
    x2: 14.507,
    y1: 11.757,
    y2: 5.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7D9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__f",
    x1: 9.012,
    x2: 9.012,
    y1: 14.535,
    y2: 2.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7D9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__g",
    x1: 13.811,
    x2: 3.528,
    y1: 11.778,
    y2: 5.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7D9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__h",
    x1: 13.825,
    x2: 3.541,
    y1: 6.243,
    y2: 12.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7D9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__i",
    x1: 9.022,
    x2: 9.022,
    y1: 4.313,
    y2: 13.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A67407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C88C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F1AD11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F5BE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F8CD4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FAD962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FCE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FEE87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FEEB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFEA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFD148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFB70E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFB70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFB70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFB70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FFF10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__j",
    x1: 9.3,
    x2: 10.929,
    y1: 9.799,
    y2: 6.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__k",
    x1: 9.061,
    x2: 11.382,
    y1: 7.448,
    y2: 7.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "maroon",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#490000",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#210000",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#090000",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__l",
    x1: 7.386,
    x2: 9.015,
    y1: 11.03,
    y2: 8.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FF7E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA29E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileChips_svg__m",
    x1: 6.934,
    x2: 8.761,
    y1: 10.555,
    y2: 10.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#090000",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#210000",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#490000",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "maroon",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red",
    stopOpacity: 0
  })))));
};
export default SvgProfileChips;